// Kolorowy badge statusu oferty SalesCRM.

import React from 'react';
import { useTranslation } from 'react-i18next';

// Stałe statusów odzwierciedlają Wise\SalesCRM\Domain\Offer\Offer::STATUS_*
export const OFFER_STATUS = {
  IN_NEGOTIATION: 1,
  ACCEPTED: 2,
  REJECTED: 3,
  EXPIRED: 4,
  CANCELED: 5,
  TO_ACCEPT: 6
} as const;

interface IProps {
  status: number | null | undefined;
  /** Opcjonalnie nadpisany label (np. z statusFormatted z backendu) */
  label?: string | null;
}

const STYLES: Record<number, { bg: string; color: string }> = {
  [OFFER_STATUS.IN_NEGOTIATION]: { bg: '#eef0f4', color: '#4b556a' },
  [OFFER_STATUS.TO_ACCEPT]: { bg: '#ede8ff', color: '#5a47e0' },
  [OFFER_STATUS.ACCEPTED]: { bg: '#e2f4ea', color: '#1f7f48' },
  [OFFER_STATUS.REJECTED]: { bg: '#fde6ea', color: '#b3142d' },
  [OFFER_STATUS.EXPIRED]: { bg: '#e6e6e6', color: '#555' },
  [OFFER_STATUS.CANCELED]: { bg: '#e6e6e6', color: '#555' }
};

const DEFAULT_STYLE = { bg: '#eef0f4', color: '#4b556a' };

const getDefaultLabel = (t: (s: string) => string, status: number): string => {
  switch (status) {
    case OFFER_STATUS.IN_NEGOTIATION:
      return t('W negocjacji');
    case OFFER_STATUS.TO_ACCEPT:
      return t('Do akceptacji');
    case OFFER_STATUS.ACCEPTED:
      return t('Zaakceptowana');
    case OFFER_STATUS.REJECTED:
      return t('Odrzucona');
    case OFFER_STATUS.EXPIRED:
      return t('Wygasła');
    case OFFER_STATUS.CANCELED:
      return t('Anulowana');
    default:
      return '';
  }
};

const OfferStatusBadge: React.FC<IProps> = ({ status, label }) => {
  const { t } = useTranslation();
  if (status == null) return null;
  const style = STYLES[status] ?? DEFAULT_STYLE;
  const text = label && label.trim() !== '' ? label : getDefaultLabel(t, status);
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '4px 10px',
        borderRadius: 12,
        fontSize: 12,
        fontWeight: 600,
        backgroundColor: style.bg,
        color: style.color,
        whiteSpace: 'nowrap'
      }}>
      {text}
    </span>
  );
};

export default OfferStatusBadge;
